var _style, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductEe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 45",
    style: {
      enableBackground: "new 0 0 42 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.pee{clip-path:url(#SVGID_2_);fill:#FF63A5;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 1.5,
    width: 42,
    height: 42
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pee",
    d: "M27.5,36c-0.6,0-1.3-0.2-1.7-0.7c-1-1-1-2.5,0-3.5l15.4-15.4c-0.6-2.1-1.6-4.1-2.8-5.8L25.2,23.8 c-0.5,0.5-1.1,0.7-1.7,0.7c-0.6,0-1.3-0.2-1.7-0.7c-1-1-1-2.5,0-3.5L35.1,6.9c-2-1.8-4.4-3.3-7.1-4.2L11.7,19 c-0.5,0.5-1.1,0.7-1.7,0.7c-0.6,0-1.3-0.2-1.7-0.7c-1-1-1-2.5,0-3.5l14-14c-0.4,0-0.8,0-1.3,0c-11.6,0-21,9.4-21,21 c0,11.6,9.4,21,21,21s21-9.4,21-21c0,0,0,0,0,0L29.2,35.3C28.7,35.8,28.1,36,27.5,36 M21.9,31.2c-0.5,0.5-1.1,0.7-1.7,0.7 c-0.6,0-1.3-0.2-1.7-0.7L13.2,26c-1-1-1-2.5,0-3.5c1-1,2.5-1,3.5,0l5.3,5.3C22.9,28.7,22.9,30.3,21.9,31.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductEe);
export default __webpack_public_path__ + "static/media/product-ee.3d98cd28ea76ae902348696d40147b66.svg";
export { ForwardRef as ReactComponent };